import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { HOME_PATHS } from '@/components/base/SectionLink';

/*
 * Page fade-in — fail-open by design. LOCKED: keep it this simple.
 * - Pure CSS keyframe animation, time-driven by the browser. No JS timers, no overlay,
 *   no click handling, no state. Nothing here can block navigation or hide the page.
 * - Worst case is "no fade"; the resting state is always fully visible.
 * - Home section paths (/, /services, ...) share one key, so moving between sections
 *   doesn't replay the fade.
 */
export default function PageFade({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const group = HOME_PATHS.includes(pathname) ? 'home' : pathname;

  return (
    <div key={group} className="page-fade">
      {children}
    </div>
  );
}